import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { StoreDecorator } from '../../../model/store/store.decorator';
import { HourFormat12Pipe } from '@df/ui/display/hour-format-12.pipe';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

@Component({
    selector: 'store-open-status',
    templateUrl: './store-open-status.html',
    styleUrl: './store-open-status.scss',
    standalone: true,
    imports: [HourFormat12Pipe, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreOpenStatusComponent {
    @Input() store?: StoreDecorator;

    get isOpenNow(): boolean | undefined {
        return this.store?.isOpenToday && this.store.isOpenNow;
    }
    get nextOpenStatus(): string | undefined {
        if (this.store) {
            const open = this.store.nextOpenDay?.open;
            if (open) {
                if (this.store.isNextOpenDayToday) {
                    return this.store.nextOpenDay?.open;
                } else if (this.store.nextOpenDayName) {
                    return [this.store.nextOpenDayName, open].join(' ');
                }
            }
        }
        return '';
    }
}
